import React from 'react';
import ReactDom from 'react-dom';

import Loader from './app/EntryPoints/Loader.jsx';
import BookmarkedArticles from './app/EntryPoints/BookmarkedArticles.jsx';
import CheckoutBillingFields from './app/EntryPoints/CheckoutBillingFields.jsx';
import CheckoutCoupons from './app/EntryPoints/CheckoutCoupons.jsx';
import CheckoutDurationSelector from './app/EntryPoints/CheckoutDurationSelector.jsx';
import CheckoutIdentification from './app/EntryPoints/CheckoutIdentification.jsx';
import ContentFeed from './app/EntryPoints/ContentFeed.jsx';
import CountdownTimer from './app/EntryPoints/CountdownTimer.jsx';
import NewsletterBlogFeed from './app/EntryPoints/NewsletterBlogFeed.jsx';
import ResearchReportsFeed from './app/EntryPoints/ResearchReportsFeed.jsx';
import TaxonomyTermsFeed from './app/EntryPoints/TaxonomyTermsFeed.jsx';
import PopularArticles from './app/EntryPoints/PopularArticles.jsx';

import ErrorBoundary from './app/Components/ErrorBoundary/index.jsx';
import ReferralProgram from './app/ReferralProgram.jsx';
import UserNotificationSettings from './app/UserNotificationSettings.jsx';
import AllEntryPoints from './app/EntryPoints/AllEntryPoints.jsx';


window.cs_article = function (event, article_slug) {
  event.preventDefault();
  // create and dispatch the event
  var trigger = new CustomEvent('cs:article', {
    detail: {
      slug: article_slug.toString(),
    },
  });
  window.dispatchEvent(trigger);
};


window.addEventListener('DOMContentLoaded', function () {
  var referralProgramContainer = document.getElementById(
    'cs-referral-program-app'
  );
  var userNotificationSettings = document.getElementById(
    'cs-user-notification-settings'
  );

  if (referralProgramContainer) {
    ReactDom.render(<ReferralProgram />, referralProgramContainer);
  }
  if (userNotificationSettings) {
    ReactDom.render(
      <ErrorBoundary>
        <UserNotificationSettings />
      </ErrorBoundary>,
      userNotificationSettings
    );
  }

  // find and load all react entry points
  var entryPoints = [
    BookmarkedArticles,
    CheckoutBillingFields,
    CheckoutCoupons,
    CheckoutDurationSelector,
    CheckoutIdentification,
    ContentFeed,
    CountdownTimer,
    NewsletterBlogFeed,
    ResearchReportsFeed,
    TaxonomyTermsFeed,
    PopularArticles
  ];
  for (var i = 0; i < entryPoints.length; i++) {
    entryPoints[i](document);
  }

    // loading and rendering all registered entrypoints
    var loader = new Loader(document,AllEntryPoints);
    loader.load();
});

